import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {FindingModel} from '@/libs/Api';
import {FindingsDataService} from '@/libs/findings/findings-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const findingsStore = registerCrudStore<FindingModel, FindingModel>(BusinessModule.Finding, new FindingsDataService());
